import { Component } from "react"

import {
    BulkSMSClickedByFilter,
    BulkSMSReceivedByFilter,
    BulkSMSClicksCountFilter,
    BulkSMSSentCountFilter,
    BulkSMSCreatedByFilter,
    BulkSMSDateSentStartFilter,
    BulkSMSDateSentEndFilter,
} from "shared/search/containers/Filter/BulkSMSFilters.tsx"
import { genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

export class BulkSMSStatisticsFilterGroup extends Component {
    static defaultProps = {
        filters: [BulkSMSSentCountFilter, BulkSMSClicksCountFilter],
        uniqueFilterGroupId: "bulkSMSStatisticsFilterGroup",
        displayLabel: "Statistics",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BulkSMSDetailsFilterGroup extends Component {
    static defaultProps = {
        filters: [BulkSMSCreatedByFilter],
        uniqueFilterGroupId: "BulkSMSDetailsFilterGroup",
        displayLabel: "Details",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BulkSMSRecipientsFilterGroup extends Component {
    static defaultProps = {
        filters: [BulkSMSReceivedByFilter, BulkSMSClickedByFilter],
        uniqueFilterGroupId: "BulkSMSRecipientsFilterGroup",
        displayLabel: "Recipients",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class BulkSMSCreatedDateFilterGroup extends Component {
    static defaultProps = {
        filters: [BulkSMSDateSentStartFilter, BulkSMSDateSentEndFilter],
        uniqueFilterGroupId: "bulkSMSCreatedDateFilterGroup",
        displayLabel: "Date",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
